import script from "./BulkApprovalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkApprovalModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkApprovalModal.vue?vue&type=style&index=0&id=7774e1c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7774e1c9"]])

export default __exports__